import styled from "styled-components";
import { theme } from "theme/theme";
import { Table } from "components";

export const WrapperAction = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 88px;
  right: 16px;
  ${theme.media.tablet} {
    position: relative;
    top: unset;
    right: unset;
    margin-bottom: 23px;
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  .ant-select-selector {
    background-color: #ffffff !important;
  }
`;

export const PaginationWrapper = styled.div`
  margin-bottom: 16px;
  text-align: center;
  ${theme.media.tablet} {
    display: flex;
    justify-content: end;
    text-align: unset;
  }
`;

export const TableStyled = styled(Table)``;
